export default __webpack_public_path__ + "static/media/coat_of_arms_at.a58a677e.png";